import EditVoucher from "../voucher/EditVoucher";
import BankPayment from "./BankPayment";
import Reconciliation from "./Reconciliation";

const ReconciliationConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/reconciliation',
      element: <Reconciliation />,
    },
    {
      path: '/bankPayment',
      element: <BankPayment />,
    },
    {
      path: '/addVoucher',
      element: <EditVoucher />,
    },
   
  ],
};

export default ReconciliationConfig;
